import createIcon from '../../createIcon';

/**
 * @component @name SportsCricket
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUuMDM2MiAxMi44MUw2LjU0NjE3IDQuMzJDNi4xNTYxNyAzLjkzIDUuNTI2MTcgMy45MyA1LjEzNjE3IDQuMzJMMi4zMDYxNyA3LjE1QzEuOTE2MTcgNy41NCAxLjkxNjE3IDguMTcgMi4zMDYxNyA4LjU2TDEwLjc5NjIgMTcuMDVDMTEuMTg2MiAxNy40NCAxMS44MTYyIDE3LjQ0IDEyLjIwNjIgMTcuMDVMMTUuMDM2MiAxNC4yMkMxNS40MjYyIDEzLjgzIDE1LjQyNjIgMTMuMiAxNS4wMzYyIDEyLjgxWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE1Ljc0MTYgMTYuMzQyTDE0LjMyNzQgMTcuNzU2MkwxOC41NyAyMS45OTg4TDE5Ljk4NDIgMjAuNTg0NkwxNS43NDE2IDE2LjM0MloiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xOC40ODYyIDlDMjAuNDE5MiA5IDIxLjk4NjIgNy40MzMgMjEuOTg2MiA1LjVDMjEuOTg2MiAzLjU2NyAyMC40MTkyIDIgMTguNDg2MiAyQzE2LjU1MzIgMiAxNC45ODYyIDMuNTY3IDE0Ljk4NjIgNS41QzE0Ljk4NjIgNy40MzMgMTYuNTUzMiA5IDE4LjQ4NjIgOVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SportsCricket = createIcon('SportsCricket', [
  [
    'path',
    {
      d: 'M15.0362 12.81L6.54617 4.32C6.15617 3.93 5.52617 3.93 5.13617 4.32L2.30617 7.15C1.91617 7.54 1.91617 8.17 2.30617 8.56L10.7962 17.05C11.1862 17.44 11.8162 17.44 12.2062 17.05L15.0362 14.22C15.4262 13.83 15.4262 13.2 15.0362 12.81Z',
      key: '1ow0cl',
    },
  ],
  [
    'path',
    {
      d: 'M15.7416 16.342L14.3274 17.7562L18.57 21.9988L19.9842 20.5846L15.7416 16.342Z',
      key: '1tqsmg',
    },
  ],
  [
    'path',
    {
      d: 'M18.4862 9C20.4192 9 21.9862 7.433 21.9862 5.5C21.9862 3.567 20.4192 2 18.4862 2C16.5532 2 14.9862 3.567 14.9862 5.5C14.9862 7.433 16.5532 9 18.4862 9Z',
      key: '5c4ilk',
    },
  ],
]);

export default SportsCricket;
